import { render, staticRenderFns } from "./DefaultLanguage.vue?vue&type=template&id=07952ada&scoped=true&"
import script from "./DefaultLanguage.vue?vue&type=script&lang=js&"
export * from "./DefaultLanguage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLanguage.vue?vue&type=style&index=0&id=07952ada&scoped=true&lang=css&"
import style1 from "./DefaultLanguage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07952ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VRadio,VRadioGroup,VSpacer})
